import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gmail",
  "use": "gmail-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 34 34\" id=\"gmail\"><circle cx=\"17\" cy=\"17\" r=\"17\" fill=\"#C5331E\" /><path fill=\"#fff\" d=\"M17.293 15.675v3.365h4.575c-.673 1.817-2.422 3.028-4.44 3.028a4.681 4.681 0 0 1-4.711-4.71 4.681 4.681 0 0 1 4.71-4.711c1.01 0 1.951.336 2.759.875l.27.202 2.018-2.625-.27-.202c-1.412-1.01-3.027-1.547-4.777-1.547-4.441 0-8.075 3.633-8.075 8.075 0 4.44 3.634 8.075 8.075 8.075 4.441 0 8.075-3.634 8.075-8.075v-1.683h-8.21v-.067Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol